class RouteHelper {
  urlPrefixForZone(context) {
    return `/`;
  }
}

const routeHelper = new RouteHelper();

export default routeHelper;


// WEBPACK FOOTER //
// ./src/helpers/RouteHelper.js